import { __assign } from "tslib";
var styledChip = function (_a) {
    var color = _a.color, avatarColor = _a.avatarColor;
    return ({
        props: { color: color },
        style: function (_a) {
            var theme = _a.theme;
            return ({
                '.MuiChip-avatar': {
                    backgroundColor: theme.palette[color].dark,
                    color: avatarColor || theme.palette[color].contrastText,
                },
            });
        },
    });
};
// TODO: update due to updated mockups and add paddings for different breakpoints
var commonStyles = {
    borderRadius: 8,
    padding: '10px 20px 20px',
};
export var componentsOptions = {
    components: {
        MuiContainer: {
            styleOverrides: {
                root: function (_a) {
                    var _b;
                    var theme = _a.theme;
                    return (_b = {},
                        // Padding for all screens smaller than sm (for mobiles)
                        _b["@media (max-width: ".concat(theme.breakpoints.values.sm, "px)")] = {
                            padding: '0 10px 15px 10px',
                        },
                        // Padding for screens bigger than sm point (for tablets)
                        _b["@media (min-width: ".concat(theme.breakpoints.values.sm, "px)")] = {
                            padding: '10px 25px',
                        },
                        // Padding for screens bigger than md point (for desktop)
                        _b["@media (min-width: ".concat(theme.breakpoints.values.md, "px)")] = {
                            padding: '25px 50px',
                        },
                        _b);
                },
            },
        },
        MuiAvatar: {
            // @todo complete styles
            styleOverrides: {
                root: function (_a) {
                    var theme = _a.theme;
                    return ({
                        border: "1px solid ".concat(theme.palette.grey[300]),
                        color: 'white',
                    });
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    textTransform: 'capitalize',
                    '.MuiChip-avatar': {
                        color: 'white',
                    },
                },
            },
            variants: [
                styledChip({ color: 'error' }),
                styledChip({ color: 'warning' }),
                styledChip({ color: 'success', avatarColor: 'white' }),
                styledChip({ color: 'info' }),
            ],
        },
        MuiAppBar: {
            styleOverrides: {
                root: function (_a) {
                    var _b;
                    var theme = _a.theme;
                    return (__assign(__assign({}, commonStyles), (_b = { backgroundColor: theme.palette.background.default, padding: '16px 40px' }, _b["@media (max-width: ".concat(theme.breakpoints.values.md, "px)")] = {
                        padding: '0 16px',
                    }, _b)));
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: commonStyles,
            },
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    padding: 0,
                    '&:last-child': {
                        paddingBottom: 0,
                    },
                },
            },
        },
        MuiDataGridPro: {
            styleOverrides: {
                root: commonStyles,
            },
        },
    },
};
